import { queryFilter } from '../../hooks/useQueryFilters';

export const WORKOUT_DELIVERY_QUERY_FILTER_SCHEMA = {
  page: queryFilter.integer(1, { min: 1 }),
  searchName: queryFilter.string(),
};
